// extracted by mini-css-extract-plugin
export default {"container":"Cards_container__i6g0V","title":"Cards_title__MNSqO","list":"Cards_list__Q3XqZ","empty":"Cards_empty__UlFae","loading":"Cards_loading__vP7o2"};